import { render, staticRenderFns } from "./smssend-form.vue?vue&type=template&id=b4a32484&scoped=true"
import script from "./smssend-form.vue?vue&type=script&lang=js"
export * from "./smssend-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a32484",
  null
  
)

export default component.exports